import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-info-details',
  templateUrl: './dialog-info-details.component.html',
  styleUrls: ['./dialog-info-details.component.scss'],
  standalone: false
})
export class DialogInfoDetailsComponent implements OnInit {
@Input() dialogTitle;
@Input() dialogDesc;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {}

}
